export const CHOOSE_CARD_THEME_EVENTS = {
  VIEW_ONBOARDING_SELECT_CARD_THEME: 'view_onboarding_select_card_theme',
  SELECT_ONBOARDING_CHOOSE_CARD_THEME: 'select_onboarding_choose_card_theme',
  VIEW_ONBOARDING_MODAL_PREVIEW_CARD_THEME:
    'view_onboarding_modal_preview_card_theme',
} as const;
